import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const vehicleWareHouseItemListTodo = createAsyncThunk('vehicleWareHouseItemList', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item-by-vehicle/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const vehicleWareHouseItemListSlice = createSlice({
    name: 'vehicleWareHouseItemList',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(vehicleWareHouseItemListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(vehicleWareHouseItemListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default vehicleWareHouseItemListSlice.reducer; 